import { ApexLocale, ApexOptions } from 'ng-apexcharts';
import { MAX_VALUE_LENGTH_FOR_SIMPLE_FORMATTING } from './constants';

// ChartOptions
export const DefaultChartConfig: ApexOptions = {
	title: {
		text: 'İsimsiz',
		style: {
			fontSize: '16px',
			color: 'var(--main-title-color)',
			fontFamily: 'Poppins, sans-serif',
		},
	},
	colors: [
		'#008FFB', // Varsayılan mavi
		'#00E396', // Varsayılan yeşil
		'#FEB019', // Varsayılan sarı
		'#FF4560', // Varsayılan kırmızı
		'#775DD0', // Varsayılan mor
		'#3F51B5', // Koyu mavi
		'#03A9F4', // Açık mavi
		'#4CAF50', // Açık yeşil
		'#F9CE1D', // Altın sarısı
		'#FF9800', // Turuncu
		'#C70039', // Ekstra koyu kırmızı
		'#900C3F', // Ekstra bordo
		'#581845', // Koyu mor
		'#1ABC9C', // Turkuaz
		'#2ECC71', // Zümrüt yeşili
		'#3498DB', // Parlak mavi
		'#9B59B6', // Açık mor
		'#34495E', // Koyu gri
		'#16A085', // Petrol yeşili
		'#F39C12', // Amber
	],
	legend: {
		show: true,
		position: 'bottom',
		itemMargin: { horizontal: 20 },
		fontSize: '12px',
		labels: {
			colors: 'var(--main-title-color)',
		},
		fontFamily: 'Poppins, sans-serif',
	},
	tooltip: { enabled: true },
	markers: { size: 5 },
	dataLabels: {
		enabled: false,
	},
	yaxis: {
		labels: {
			style: {
				colors: 'var(--main-title-color)',
				fontSize: '12px',
				fontFamily: 'Poppins, sans-serif',
				cssClass: 'apexcharts-yaxis-label',
			},
			formatter: chartFormatter,
		},
	},
	xaxis: {
		type: 'category',
		tickPlacement: 'between',
		labels: {
			rotate: 0,
			style: {
				colors: 'var(--main-title-color)',
				fontSize: '12px',
				fontFamily: 'Poppins, sans-serif',
			},
			formatter: chartFormatter,
		},
	},
	grid: {
		position: 'back',
		show: true,
		borderColor: 'var(--main-title-color)',
		strokeDashArray: 7,
		xaxis: {
			lines: {
				show: true,
			},
		},
		yaxis: {
			lines: {
				show: true,
			},
		},
	},
	plotOptions: {
		bar: {
			horizontal: false,
			borderRadius: 2,
			// borderRadiusApplication: 'around',
			// borderRadiusWhenStacked: 'last',
			columnWidth: '40%',
			barHeight: '40%',
			distributed: false,
			rangeBarOverlap: true,
			rangeBarGroupRows: false,

			// dataLabels: {
			//   total: {
			//     enabled: false,
			//     style: {
			//       color: '#a1a4b5',
			//       fontSize: '12px',
			//       fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
			//     },
			//   },
			// },
		},
	},
};

export function chartFormatter(value: string | number): string | string[] {
	if (typeof value === 'bigint' || typeof value === 'number') {
		const notation = value >= MAX_VALUE_LENGTH_FOR_SIMPLE_FORMATTING ? 'compact' : 'standard';
		return new Intl.NumberFormat('tr-TR', {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
			notation: notation,
		}).format(Number(value));
	} else {
		return value;
	}
}

export const APEX_CHART_LOCALE_TR: ApexLocale = {
	name: 'tr',
	options: {
		months: [
			'Ocak',
			'Şubat',
			'Mart',
			'Nisan',
			'Mayıs',
			'Haziran',
			'Temmuz',
			'Ağustos',
			'Eylül',
			'Ekim',
			'Kasım',
			'Aralık',
		],
		shortMonths: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
		days: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
		shortDays: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
		toolbar: {
			exportToSVG: 'SVG İndir',
			exportToPNG: 'PNG İndir',
			exportToCSV: 'CSV İndir',
			selection: 'Seçim',
			selectionZoom: 'Seçim Yakınlaştır',
			zoomIn: 'Yakınlaştır',
			zoomOut: 'Uzaklaştır',
			pan: 'Kaydır',
			reset: 'Yakınlaştırmayı Sıfırla',
		},
	},
};

export const APEX_CHART_LOCALE_EN: ApexLocale = {
	name: 'en',
	options: {
		months: [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		],
		shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		toolbar: {
			exportToSVG: 'Download SVG',
			exportToPNG: 'Download PNG',
			selection: 'Selection',
			selectionZoom: 'Selection Zoom',
			zoomIn: 'Zoom In',
			zoomOut: 'Zoom Out',
			pan: 'Panning',
			reset: 'Reset Zoom',
		},
	},
};
